import React, { useState } from 'react';

import { ActionPanelCard } from '@eika/action-panel-card';
import { IconTypes } from '@eika/icon';

import FavoriteAccountModal from '../../components/FavoriteAccountModal/FavoriteAccountModal';
import { Content } from '../../components/shared/Content';
import { useConfig } from '../../defaultConfig';
import useTranslation from '../../hooks/useTranslation';
import { EditAccountList, DragAndDropAccountsList } from './components';

import './EditAccountOverview.scss';

const EditAccountOverview: React.FC = () => {
    const [showListModal, setShowListModal] = useState<boolean>(false);
    const [showFavoriteAccountModal, setShowFavoriteAccountModal] = useState<boolean>(false);
    const translated = useTranslation();
    const { createAccountsLink, featureToggles } = useConfig();
    return (
        <>
            <Content className="edit-account-overview-container">
                <ActionPanelCard
                    title={translated.editDisplayAndOrderOfAccounts}
                    icon={IconTypes.PENN_24}
                    onClick={() => setShowListModal(true)}
                    id="edit-preferred-accounts-panel"
                />
                <ActionPanelCard
                    title={translated.favoriteAccount.favoriteAccountCardTitle}
                    icon={IconTypes.PENN_24}
                    onClick={() => setShowFavoriteAccountModal(true)}
                    id="select-favorite-account-panel"
                />
                {createAccountsLink?.url && !featureToggles.disableAccountCreation && (
                    <ActionPanelCard
                        title={translated.accountsList.createAccount}
                        icon={IconTypes.PLUSS_24}
                        onClick={() => {
                            window.location.href = createAccountsLink?.url;
                        }}
                        id="create-account-panel"
                    />
                )}
            </Content>
            {featureToggles.enableAccountsDnd ? (
                <DragAndDropAccountsList show={showListModal} setShow={setShowListModal} />
            ) : (
                <EditAccountList show={showListModal} setShow={setShowListModal} />
            )}
            <FavoriteAccountModal showModal={showFavoriteAccountModal} setShow={setShowFavoriteAccountModal} />
        </>
    );
};

export default EditAccountOverview;
